export default {
  namespaced: true,
  state: {
    // Course-student record being edited; set by CourseEdit/AddCourse, read by the course dialogs.
    selecting: {},
  },
  mutations: {
    SET_DETAIL(state, student) {
      state.selecting = student;
    },
  },
};
